import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { of } from 'rxjs';

import { ShortProfile } from '@apps/auth/domain/models';
import { DetailedUserComponent } from '../detailed-user/detailed-user.component';

@Component({
    selector: 'aa-detailed-user-by-profile',
    templateUrl: './detailed-user-by-profile.component.html',
    styleUrls: [
        '../detailed-user/detailed-user.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DetailedUserByProfileComponent extends DetailedUserComponent
{
    @Input() profile: ShortProfile;

    ngOnInit ()
    {
        this.user = of(this.profile);
    }
}
